import { PipelinesLegacyRedirect } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { workspaceRouteParams } from '@/services/router/workspace-id-param';

export const Route = createFileRoute('/pipelines/workspaces/$workspaceId/')({
  params: workspaceRouteParams,
  component: PipelinesLegacyRedirect,
});
